import "./App.css";
import Navbar from "./components/layout/Navbar";
import { Route, Switch } from "react-router-dom";

import Soccer from "./components/soccer/Soccer";
import Cricket from "./components/cricket/Cricket";
import Formula from "./components/formula/Formula";
import SoccerAll from "./components/soccer/SoccerAll";
import FormulaLiveScore from "./components/formula/FormulaLiveScore";
import MatchScore from "./components/soccer/MatchScore";
import AllMatchesNow from "./components/soccer/AllMatchesNow";
import League from "./components/soccer/League";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Switch>
        <Route exact path="/" component={SoccerAll} />
        <Route path="/cricket" component={Cricket} />
        <Route path="/soccer-live" component={Soccer} />
        <Route path="/soccer-all-matches" component={AllMatchesNow} />
        <Route path="/formula-home" component={Formula} />
        <Route path="/formula-live" component={FormulaLiveScore} />
        <Route path="/matchscore/:fid" component={MatchScore} />
        <Route path="/league/:sid" component={League} />
      </Switch>
    </div>
  );
}

export default App;
